module.exports = __webpack_public_path__ + "img/thinking.bb38706b.png";